import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import * as Icon from '@mui/icons-material/';
import { createBrowserHistory } from 'history';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import GrupoProdutoController from '../../../../controllers/GrupoProdutoController';
import { toast } from 'react-toastify';
import { useLocation} from 'react-router-dom';

export default function GrupoProdutoCadastrar() {
  const { userId } = useSelector((state: any) => state.Authentication);

  const history = createBrowserHistory();
  const [single, setSingle] = useState<any>(null);
  const { id } = useParams();
  const GrupoProdutoId = id ? parseInt(id, 10) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  useEffect(() => {
    if (GrupoProdutoId !== null && GrupoProdutoId !== undefined) {
      getSingle(GrupoProdutoId);
    }
  }, [GrupoProdutoId]);

  const getSingle = async (GrupoProdutoId: number) => {
    const Response = await GrupoProdutoController.ListarUnico(GrupoProdutoId);

    setSingle(Response.Data);
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ) => {
    if (GrupoProdutoId === null) {
      const response = await GrupoProdutoController.Adicionar(values);

      if (response.StatusCode === 204) {
        toast('Grupo Produto incluido com sucesso!', {
          type: 'success',
        })
        resetForm();
      } else if(response.StatusCode === 500) {
        toast(response.Data, {
          type: 'error',
        })
        resetForm();
      }
    } else {
      EditarContato(values, { setSubmitting, resetForm });
    }

    setSubmitting(false);
  };

  const EditarContato = async (
    values: any,
    { setSubmitting }: any
  ) => {
    const request = {
      GrupoProdutoId: GrupoProdutoId,
      ...values,
    };

    const response = await GrupoProdutoController.Atualizar(request);

    if (response.StatusCode === 204) {
      toast('Grupo produto atualizado com sucesso!', {
        type: 'success',
      })
    } else {
      toast('Erro ao atualizar o grupo produto!', {
        type: 'error',
      })
    }
    setSubmitting(false);
  };

  const initialValues = {
    UsuId: userId,
    SiglaID: single?.grp_siglaid || '',
    Descricao: single?.grp_descricao || '',
  };

  const validationSchema = Yup.object().shape({
    SiglaID: Yup.string()
        .required('Campo Obrigatorio!')
        .min(3, 'O Campo deve ter 3 caracteres')
        .max(3, 'O Campo deve ter 3 caracteres')
        .matches(/^[a-zA-Z]*$/, 'Apenas caracteres alfabéticos são permitidos'),
    Descricao: Yup.string()
      .required('Campo Obrigatorio!')
      .min(4, 'O Campo deve ter no minimo 4 caracteres')
  });

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
    >
      <HeaderComponent text={'CADASTRO DE GRUPO PRODUTOS'} className={'mb-5'} />

      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors }) => (
          <Form>
            <BoxButtons>
              <Button
                variant='contained'
                onClick={() => history.back()}
                color='warning'
                startIcon={<Icon.ArrowBack />}
              >
                Voltar
              </Button>
              <Button
                type={'submit'}
                variant='contained'
                color='success'
                startIcon={<Icon.Save />}
                disabled={duploClick}
              >
                Salvar
              </Button>
            </BoxButtons>
            <fieldset disabled={duploClick}>
            <Field
              name='SiglaID'
              required
              as={TextField}
              label='Sigla'
              placeholder=''
              type='text'
              error={Boolean(errors?.SiglaID)}
              helperText={errors?.SiglaID}
            />

            <Field
              name='Descricao'
              required
              as={TextField}
              label='Descricao'
              placeholder=''
              type='text'
              error={Boolean(errors?.Descricao)}
              helperText={errors?.Descricao}
            />
            </fieldset>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
